import * as React from "react";
import { StreamChart } from "./charts/StreamChart";
import { DownloadChart } from "./charts/DownloadChart";
import { KeywordChart } from "./charts/KeywordChart";
import { ResultsFoundChart } from "./charts/ResultsFoundChart";
import { Field, QueryProvider } from "../../../components/context/query";

const allowedFields: Field[] = [{
    dataField: 'keyword',
    dataType: 'string'
}]
export class Search extends React.Component {
    render() {
        return <div className="dashboard">
            <div className='charts'>
                <QueryProvider fields={allowedFields}>{({ filter }) => {
                    return <div className='bpm-container'>
                        <div className='row'>
                            <div className='col'>
                                {filter}
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <KeywordChart />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <ResultsFoundChart />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <DownloadChart />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <StreamChart />
                            </div>
                        </div>
                    </div>
                }}</QueryProvider>
            </div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/pages/Statistics/Search/Search.tsx